import React, { useState } from 'react'

import { CommonTabs } from '@/components/common'
import { ButtonSection } from './ButtonSection'
import { TextFieldSection } from './TextFieldSection'
import { CheckboxSection } from './CheckboxSection.jsx'
import { RadioSection } from './RadioSection.jsx'
import { SelectSection } from './SelectSection.jsx'
import { LoaderSection } from './LoaderSection.jsx'
import { DatePickerSection } from './DatePickerSection'
import { TabsSection } from './TabsSection.jsx'
import { SliderSection } from './SliderSection.jsx'
import { DialogSection } from './DialogSection.jsx'
import { AddressSection } from './AddressSection.jsx'
import { MenuSection } from './MenuSection.jsx'

import {
  StyledAlert,
  StyledSection,
  StyledContainer,
  StyledHeaderBox,
  StyledMainTitle,
  StyledHeaderDescription,
} from '../styled.jsx'

export const CommonComponents = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeaderBox>
          <StyledMainTitle variant='h4' gutterBottom>
            Common Components Reference
          </StyledMainTitle>
          <StyledHeaderDescription variant='body1'>
            Visual reference guide for all available common components including
            buttons, date pickers, text fields, textareas, checkboxes, selects,
            menus, and loaders
          </StyledHeaderDescription>
        </StyledHeaderBox>

        <StyledAlert severity='info'>
          All components are built with Material-UI foundation and enhanced
          functionality.
        </StyledAlert>

        <CommonTabs
          id='component'
          value={activeTab}
          onChange={handleTabChange}
          tabs={[
            {
              label: 'Button',
              content: <ButtonSection />,
            },
            {
              label: 'Text Input',
              content: <TextFieldSection />,
            },
            {
              label: 'Select',
              content: <SelectSection />,
            },
            {
              label: 'Date Picker',
              content: <DatePickerSection />,
            },
            {
              label: 'Address',
              content: <AddressSection />,
            },
            {
              label: 'Menu',
              content: <MenuSection />,
            },
            {
              label: 'Checkbox',
              content: <CheckboxSection />,
            },
            {
              label: 'Radio',
              content: <RadioSection />,
            },
            {
              label: 'Loader',
              content: <LoaderSection />,
            },
            {
              label: 'Dialog',
              content: <DialogSection />,
            },
            {
              label: 'Tabs',
              content: <TabsSection />,
            },
            {
              label: 'Slider',
              content: <SliderSection />,
            },
          ]}
        />

        {/* Panels are rendered via CommonTabs */}
      </StyledContainer>
    </StyledSection>
  )
}
